import React from "react";

const Circle = ({color}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9C0 4.032 4.032 0 9 0C13.968 0 18 4.032 18 9C18 13.968 13.968 18 9 18C4.032 18 0 13.968 0 9ZM16.2 9C16.2 5.031 12.969 1.8 8.99999 1.8C5.03099 1.8 1.79999 5.031 1.79999 9C1.79999 12.969 5.03099 16.2 8.99999 16.2C12.969 16.2 16.2 12.969 16.2 9Z"
        fill={color}        
        fillOpacity="1"
      />
    </svg>
  );
};

export default Circle;
